import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {
  AbstractControl,
  UntypedFormGroup,
} from '@angular/forms';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})

export class DateInputComponent implements OnInit {
  @Input() inputForm: UntypedFormGroup;
  @ViewChild('monthElement') monthElement: ElementRef;
  @ViewChild('yearElement') yearElement: ElementRef;

  get day(): AbstractControl {
    return this.inputForm?.get('date.day');
  }

  get month(): AbstractControl {
    return this.inputForm?.get('date.month');
  }

  get year(): AbstractControl {
    return this.inputForm?.get('date.year');
  }

  constructor() { }

  ngOnInit(): void {
    this.day.valueChanges.subscribe((value) => {
      if (value?.length === 2) {
        this.monthElement.nativeElement.focus();
      }
    });
    this.month.valueChanges.subscribe((value) => {
      if (value?.length === 2) {
        this.yearElement.nativeElement.focus();
      }
    });
  }

}
